module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-KHNLR9G","includeInDevelopment":false,"routeChangeEventName":"route-change","defaultDataLayer":null},
    }]
